import { render, staticRenderFns } from "./proType-add.vue?vue&type=template&id=46c45213&scoped=true&"
import script from "./proType-add.vue?vue&type=script&lang=js&"
export * from "./proType-add.vue?vue&type=script&lang=js&"
import style0 from "./proType-add.vue?vue&type=style&index=0&id=46c45213&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c45213",
  null
  
)

export default component.exports